import { render } from "./Home.vue?vue&type=template&id=36b2c637&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=36b2c637&scoped=true&lang=css"
import "./Home.vue?vue&type=style&index=1&id=36b2c637&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b2c637"]])

export default __exports__